import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../common/data.service';
import { AppTokenHandler } from '../../common/app-token-handler';
import { AlertService } from '../../common/alert.service';
import { AzureAuthService } from 'src/app/common/azure-auth.service';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from 'src/app/common/login.service';
@Component({
  standalone: false,
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    //debugger;
    token: any;
    Azure_token :string = ""
    private readonly _destroying$ = new Subject<void>();

    constructor(private appToken: AppTokenHandler,private _azureAuthService: AzureAuthService,
        private loginService : LoginService,
        private gservice: DataService, private route: Router, private alertService: AlertService) {
       }
       ngOnDestroy(): void {
        this._destroying$.next();
        this._destroying$.complete();
      }
     
    ngOnInit() {
        //debugger;
        if (environment.isHostingAzure)
            this.acquireAzureToken();
          else
            this.GetUserDetails();
        
    }
    async acquireAzureToken() {
        //debugger;
        this._azureAuthService.handleQueryParameters()
          .pipe(
            takeUntil(this._destroying$),
            catchError(error => {
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (result) => {
              if (result) {
                //debugger;
                this.Azure_token = result;
                this.appToken.setAzureTokenLocalStorage(this.Azure_token);
               // this.GetUserDetails();
               this.loginService.GetUserDetails(this.Azure_token);
 
              }
            }
          });
      }
    GetUserDetails() {
        //debugger;
        //this.isSpinning = true;
        if (this.appToken.getSessionToken().length <= 0) {
            //debugger;
            this.gservice.Login().subscribe((data: any) => {
                //debugger;
                this.appToken.setSessionToken(data);
                this.route.navigate(['/home']);
            },
                (error: Response) => {
                    if (error.status <= 0) {
                        this.route.navigate(['/badrequest']);
                    }
                    else if (error.status == 401) {
                        this.route.navigate(['/unauthorize']);
                    }
                    else {
                        this.alertService.notify('error', 'Server Error', error.statusText);
                    }
                });
        }
        else {
            this.route.navigate(['/home']);
        }
    };
}
